var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C5.22 0 1.332 3.731 1.332 8.318c0 6.224 7.953 11.357 8.292 11.572a.698.698 0 00.752 0c.34-.215 8.293-5.348 8.293-11.572C18.669 3.73 14.78 0 10 0zm0 18.453C8.46 17.38 2.734 13.07 2.734 8.318c0-3.814 3.26-6.916 7.266-6.916 4.007 0 7.267 3.102 7.267 6.916 0 4.745-5.728 9.062-7.267 10.135z",
    fill: "#4E8278"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.809a3.953 3.953 0 00-3.949 3.948A3.953 3.953 0 0010 11.706a3.953 3.953 0 003.949-3.949A3.953 3.953 0 0010 3.81zm0 6.494a2.55 2.55 0 01-2.547-2.546A2.55 2.55 0 0110 5.21a2.55 2.55 0 012.547 2.547A2.55 2.55 0 0110 10.303z",
    fill: "#4E8278"
  })));
}
export default SvgMapPin;